import PropTypes from 'prop-types';

import { FormattedMessage } from '@zenbusiness/application-commons-intl';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';

function SectionGrid({
  title,
  children,
  gridColumns = { md: 2, lg: 4 },
  gap = { xs: 3, md: 2 }
}) {
  return (
    <Stack gap={3}>
      <Text size="xl" weight="medium">
        <FormattedMessage id={title} />
      </Text>
      <Stack
        direction="row"
        flexWrap="wrap"
        gap={gap}
        sx={{
          display: { xs: 'flex', md: 'grid' },
          gridTemplateColumns: {
            md: `repeat(${gridColumns.md}, 1fr)`,
            lg: `repeat(${gridColumns.lg}, 1fr)`
          }
        }}
      >
        {children}
      </Stack>
    </Stack>
  );
}

SectionGrid.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  gridColumns: PropTypes.shape({}),
  gap: PropTypes.shape({})
};

export default SectionGrid;
